/**
 * Slug validation policy — Zod-free primitive constants.
 *
 * Shared between `@artemis/validators`' `slugSchema` (Zod) and the
 * identity domain `Slug` value object. The domain layer imports these
 * constants through the package barrel (AUDIT-107 boundary discipline:
 * domain may depend on `@artemis/validators` primitives but not on
 * Zod at runtime).
 *
 * Values are byte-identical to the pre-extraction literals in
 * `apps/api/src/modules/identity/domain/user/slug.vo.ts:14-18`
 * and `packages/validators/src/slug.ts:5-9`, so the three error
 * message variants emitted by both the Zod schema and the VO stay
 * stable for callers and serialised error payloads:
 *
 *   - min-length: `String must contain at least 3 character(s)`
 *   - max-length: `String must contain at most 63 character(s)`
 *   - pattern:    `SLUG_PATTERN_MESSAGE` (verbatim below)
 */
export const SLUG_MIN_LENGTH = 3;
export const SLUG_MAX_LENGTH = 63;
export const SLUG_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;
export const SLUG_PATTERN_MESSAGE = 'Slug must be lowercase alphanumeric with single hyphens, no leading/trailing hyphens';
/**
 * Amenity-scoped minimum slug length (SCRUM-262).
 *
 * The curated DS-010 amenity catalog contains a single legitimate 2-character
 * slug (`tv`) — the only sub-3 slug across all 218 rows. Identity slugs keep
 * the stricter floor of `SLUG_MIN_LENGTH` (3); amenity slugs relax the minimum
 * to 2 so the manifest rehydrates fully. Everything else about amenity slug
 * validation (max length 63, charset/format, lowercase, no leading/trailing
 * or double separators) is identical to the identity rule.
 */
export const AMENITY_SLUG_MIN_LENGTH = 2;
//# sourceMappingURL=slug.js.map